<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <app-alert v-if="error" @dismissed="onDismissed" :text="error.message"></app-alert>
            <phone-ui @userVerified="fetchUserData"></phone-ui>
          </v-flex>
      </v-layout>
    </v-container>

  </v-main>
</template>

<script>
export default {
  data: () => ({
    drawer: null,
    email: '',
    password: '',
    signUp: false,
    name: '',
    nameRules: [
      v => !!v || 'Name is required',
      v => (v && v.length <= 10) || 'Name must be less than 10 characters',
    ],
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],

  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/fulfillments')
      }
    }
  },
  methods: {
    fetchUserData (user) {
      this.$store.dispatch('fetchUserData', user)
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }
}
</script>
